import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';

import { stringInputSpec, stringSelectSpec } from '../../lib/editing-configs';

import './tile.less';

class Tile extends Component {
  constructor(props) {
    super(props);
    this.state = { insideBox: false };

    this.handleHover = this.handleHover.bind(this);
  }

  handleHover() {
    const { insideBox } = this.state;
    this.setState({
      insideBox: !insideBox,
    });
  }

  render() {
    const {
      iconUrl,
      highlightIconUrl,
      linkUrl,
      mobileLinkUrl,
      size,
      title,
      type,
    } = this.props;
    // in case highlighted icon is not specified
    const targetHighlightIconUrl = highlightIconUrl || iconUrl;
    // in case mobile link is not specified
    const targetMobileLinkUrl = mobileLinkUrl || linkUrl;

    const href = size !== 'sm' ? linkUrl : targetMobileLinkUrl;
    return (
      <div className="category-list__category">
        <a
          href={type === 'active' ? href : null}
          className={classNames([
            this.state.insideBox ? 'hover' : '',
            type,
            'category-tiles__tile btn btn-category',
          ])}
          onMouseEnter={this.handleHover}
          onMouseLeave={this.handleHover}
        >
          <span
            className="icon"
            aria-hidden="true"
            style={{
              backgroundImage: `url('${
                this.state.insideBox ? targetHighlightIconUrl : iconUrl
              }')`,
            }}
          />
          <div className="category-text-wrapper">
            <div className="category-text">{title}</div>
          </div>
        </a>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Tile.propTypes = {
  iconUrl: PropTypes.string,
  highlightIconUrl: PropTypes.string,
  linkUrl: PropTypes.string,
  mobileLinkUrl: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['active', 'inactive']),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Tile.defaultProps = {
  size: '',
  type: 'active',
  title: 'Insert title here',
};

Tile.getEditingConfig = () => [
  stringInputSpec('title', 'Title'),
  stringInputSpec('linkUrl', 'Link URL'),
  stringInputSpec('mobileLinkUrl', 'Mobile Link URL', {
    help: 'Will default to link URL if left blank',
  }),
  stringInputSpec('iconUrl', 'Icon Image URL'),
  stringInputSpec('highlightIconUrl', 'Icon Image URL (when highlighted)', {
    help: 'Will default to icon URL field if left blank',
  }),
  stringSelectSpec(
    'type',
    'Active / Inactive',
    [
      {
        value: 'active',
        label: 'active',
      },
      {
        value: 'inactive',
        label: 'inactive',
      },
    ],
    {
      help: 'Select whether the link on the tile is active or inactive',
    }
  ),
];

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Tile.displayName = 'Tile';

export default connect(
  createStructuredSelector({
    size: property('mediaQuery'),
  })
)(Tile);
